<template>
  <div>
    <div id="canvas-div">
      <canvas :id="`canvas-radial${this.attributes.model}`"></canvas>
    </div>
  </div>
</template>

<script>
import { RadialGauge } from "canvas-gauges";
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";

export default {
  name: "Gauge",
  mixins: [dataComponentMixin],
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  async created() {
    // we use httpMixin. request to have the list of experience. Fill array "experience" with results.
    this.definitions = this.config.elements;
  },
  mounted() {
    var minimum = 0;
    var step = parseInt(this.attributes.step);
    var majorTick = [];
    while (minimum < parseInt(this.config.attributes.max) + 1) {
      majorTick.push(minimum);
      minimum = minimum + step;
    }
    if (this.value) this.options.value = this.value;
    else this.value = 0;
    this.options.renderTo = this.$el;

    this.chartRadial = new RadialGauge({
      renderTo: "canvas-radial" + this.attributes.model,
      width: 200,
      height: 200,
      units: this.attributes.model,
      minValue: 0,
      startAngle: 90,
      ticksAngle: 180,
      valueBox: true,
      valueText: this.value,
      colorValueBoxBackground: "white",
      maxValue: this.attributes.max,
      majorTicks: majorTick,
      minorTicks: 4,
      strokeTicks: true,
      highlights: [
        {
          from: parseInt(this.attributes.highlightmin),
          to: parseInt(this.attributes.highlightmax),
          color: "rgba(200, 50, 50, .75)",
        },
      ],
      colorPlate: "#000",
      colorNumbers: "#eee",
      borderShadowWidth: 0,
      borders: true,
      needleType: "arrow",
      needleWidth: 2,
      needleCircleSize: 7,
      needleCircleOuter: false,
      needleCircleInner: false,
      animationRule: "elastic",
      animationDuration: 1500,
    }).draw();
  },
  watch: {},
  methods: {
    prepare() {},
    tickFlux(flux_structure) {
      for (var i in flux_structure.data) {
        this.chartRadial.options.value = parseInt(
          flux_structure.data[i].number_value
        );
        this.chartRadial.update();
        this.value = flux_structure.data[i][this.attributes.data];

        if (flux_structure.data[i]["time"] > this.$store.getters.progress) {
          //console.log(flux_structure.data[i]["time"], this.$store.getters.progress);
          break;
        }
      }
    },
    tick() {
      this.value = this.getDataForFlux(this.attributes.name).number_value;
      this.chartRadial.update();
      // Updates the DOM for each flux (rendering)
      Object.keys(this.objectData).forEach((flux_identifier) => {
        let flux_structure = this.getFluxStructure(flux_identifier);
        this.tickFlux(flux_structure);
      }, this);
    },
  },
};
</script>
